import { css } from '@emotion/react';
import { theme } from '../../../../domain/theme';
import { contentPackageMediumStyle } from './contentPackageMediumStyle';

export const contentPackageLeadStyle = (bgColor, tint, gradient) => {
  const isLightBg = ['white', '#f7f7f7'].includes(bgColor);
  const mediumStyle = contentPackageMediumStyle(bgColor);

  return {
    container: mediumStyle.container,
    image: {
      container: mediumStyle.image.container,
      picture: css`
        picture {
          ${theme.mq.tablet} {
            ${tint && `filter: brightness(${100 - tint}%);`}
            ${gradient &&
            `:after {
            content: '';
            position: absolute;
            bottom: 0;
            display: block;
            width: 100%;
            height: 50%;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0), black);
            opacity: ${gradient}%;
          };`}
          }
        }
      `,
      cta: [
        mediumStyle.image.cta,
        css`
          ${theme.mq.tablet} {
            bottom: 40px;
            left: 24px;
          }
        `
      ]
    },
    text: {
      container: [
        mediumStyle.text.container,
        css`
          padding-inline: 20px;
          ${theme.mq.tablet} {
            padding-inline: 0;
            position: absolute;
            right: 0;
            bottom: 40px;
            left: 0;
            z-index: 1;
            box-sizing: border-box;
            width: calc(100% - 200px);
            margin: auto;
            padding: 0;
            color: white;
          }
        `
      ],
      sponsored: [
        mediumStyle.text.sponsored,
        css`
          div {
            ${theme.mq.tablet} {
              filter: ${isLightBg ? 'invert(100%)' : null};
            }
          }
        `
      ],
      taxonomy: [
        mediumStyle.text.taxonomy,
        css`
          ${theme.mq.tablet} {
            color: #e0e0e0;
          }
        `
      ],
      title: [
        mediumStyle.text.title,
        css`
          ${theme.mq.tablet} {
            -webkit-line-clamp: 2;
          }
          ${theme.mq.small_desktop} {
            -webkit-line-clamp: 2;
          }

          a {
            ${theme.mq.tablet} {
              color: white;
            }
          }
          ${theme.mq.tablet} {
            ${theme.font.family('bold')};
            font-size: 1.5rem;
            line-height: 1.75rem;
          }
          ${theme.mq.large_desktop} {
            font-size: 3rem;
            line-height: initial;
          }
        `
      ],
      subtitle: [
        mediumStyle.text.subtitle,
        css`
          ${theme.mq.tablet} {
            -webkit-line-clamp: 2;
          }
          ${theme.mq.small_desktop} {
            -webkit-line-clamp: 2;
          }
        `
      ],
      cta: [
        mediumStyle.text.cta,
        css`
          a {
            ${theme.mq.tablet} {
              color: white;
            }
          }
        `
      ]
    }
  };
};
